<template>
  <div>
    <b-modal ref="my-modal" size="xl" hide-footer title="">
      <div class="d-block text-center">
        <!--        <h3>Hello From My Modal!</h3>-->
      </div>

      <a role="button" class="btn btn-primary" @click="hideModal()"><i class="fas fa-save"></i></a>
<!--      <a role="button" class="btn btn-danger" @click="hideModal"><i class="fas fa-times-circle"></i></a>-->
      <div class="checkbox">
        <label><input type="checkbox" value="" v-model="menu.RedirectEnable">啟用轉向網頁</label>

        <div v-if="menu.RedirectEnable">
          <label class="radio-inline"><input type="radio" value="" name="" v-model="menu.RedirectUrlTarget">本頁</label>
          <label class="radio-inline"><input type="radio" value="_blank" name="" v-model="menu.RedirectUrlTarget">新的分頁</label>
          <input v-if="menu.RedirectEnable" type="url" class="form-control" placeholder="" v-model="menu.RedirectUrl" style="width:'800px'">
        </div>

      </div>
<!--            <b-button class="mt-2" variant="btn btn-primary" block @click="submit()">儲存</b-button>-->
<!--      <b-button class="mt-3" variant="btn btn-danger" block @click="hideModal">關閉</b-button>-->
    </b-modal>

  </div>
</template>

<script>

/**

 **/


import {
  QueryType_Content,
  QueryType_Block,
} from "./js/rotaryDeclare";

export default {
  components: {},
  //name: "contentEdit",
  props: ["menu"],
  data: function () {
    return {
      dataReady: false,
      formData: {
        name: "",
      },
      datasTemplate:{
        HtmlContent:"",
        CloudPhotoUrl:"",
        Images:[],
        Videos:[],
        Files:[],
      },
      QueryType_Content:QueryType_Content,
      QueryType_Block:QueryType_Block,
    };
  },
  methods: {
    showModal() {
      // this.loadData()
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    returnModal(value) {
      // this.$refs['my-modal'].toggle('#toggle-btn')

      // onePageUtil.webPartHtml_Save(this.areaId,this.blockId,this.formData.content)

      this.$emit('returnOk',value);
    },
    // loadData() {
    //   // let data=await apiUtil.api_SupplierTODO("12138114-01")
    //   // this.data=data
    //   this.loadDataByQueryType(this.QueryType_Block +"_"+ this.SystemId)
    //
    //   // debugger // eslint-disable-line
    // },
    // loadDataByQueryType(queryType) {
    //   // let data=apiAdmin.api_getContent(this.queryType);
    //   // debugger // eslint-disable-line
    //   // console.log(data);
    //   let that=this;
    //   apiAdmin.api_getContent(queryType).then((data)=>{
    //     let dataApi=apiAdmin.initReturnString(data.data.data);
    //
    //     if (dataApi===""){
    //       that.datas=JSON.parse(JSON.stringify(that.datasTemplate));
    //     }else{
    //       that.datas=dataApi;
    //     }
    //   })
    // },
    // // submit(){
    // //   // for (let i = 0; i < this.datas.Details.length; i++) {
    // //   //   let item = this.datas.Details[i];
    // //   //
    // //   //   if (item.Year===""){
    // //   //     util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
    // //   //     return;
    // //   //   }
    // //   // }
    // //
    // //   apiAdmin.api_saveContent(this.QueryType_Block +"_"+ this.SystemId,this.datas).then((data)=>{
    // //     console.log(data);
    // //     alert('儲存成功')
    // //   })
    // // },
  },
  mounted() {
    // this.SystemId=this.$route.query.SystemId

  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
}
</style>
